import React from "react";
import { Form } from "react-bootstrap";
import IcomoonIcon from "@icons/IcomoonIcon";

interface SntInfoTextProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
}

const SntInfoText: React.FC<SntInfoTextProps> = ({ children, ...props }) => {
  return (
    <div {...props}>
      <div className="d-flex">
        <div style={{ minWidth: 16 }} className={`me-2`}>
          <IcomoonIcon icon="info"></IcomoonIcon>
        </div>
        <div className="flex-grow-1">
          <Form.Text>{children}</Form.Text>
        </div>
      </div>
    </div>
  );
};

export default SntInfoText;
